import { fetchFamilies } from '@gn-audio/core/api/product-catalogue/fetch-families';
import { fetchFamiliesAttributes } from '@gn-audio/core/api/product-catalogue/fetch-families-attributes';
import { IAttribute } from '@gn-audio/core/api/product-catalogue/models/attribute';
import { IFamily } from '@gn-audio/core/api/product-catalogue/models/family';
import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models/product-with-attributes';
import { ICollectionDictionary } from '@gn-audio/core/common/models/collection-dictionary';

import { fetchSegmentTypeConfiguration } from '../utils/fetch-segment-type-configuration';
import { getComparisonSegmentType } from '../utils/get-comparison-segment-type';

import { IProductComparisonAttributeSet } from './product-comparison-attribute-set';
import { ProductComparisonSegmentTypeIndex } from './product-comparison-segment-type';
import { IProductComparisonSegmentTypeConfiguration } from './product-comparison-segment-type-configuration';

export interface IProductComparisonBaseComponent {
  attributeSets?: IProductComparisonAttributeSet[];
  configurationId?: string;
  loading: boolean;
  products?: IFamily[] | null;
  productAttributes?: IAttribute[][];

  getAttributes(families: IFamily[] | null): ng.IPromise<IFamily[] | null>;
  getSegmentTypeConfiguration(families: IFamily[] | null): ng.IPromise<IFamily[] | null>;
  setFemilies(familyIds: number[]): ng.IPromise<IFamily[] | null>;
}

export class ProductComparisonBaseComponent implements IProductComparisonBaseComponent {
  public attributes?: ICollectionDictionary<IProductWithAttributes> | null;
  public configurationId?: string;
  public products?: IFamily[] | null;
  public productAttributes?: IAttribute[][];
  public attributeSets?: IProductComparisonAttributeSet[];
  public loading = true;

  constructor(protected $q: ng.IQService) {
    this.stopLoading = this.stopLoading.bind(this);
  }

  public get hasProducts(): boolean {
    return this.products?.length > 0;
  }

  public getAttributes(families: IFamily[] | null): ng.IPromise<IFamily[] | null> {
    return this.$q
      .when(fetchFamiliesAttributes(families.map((x: IFamily) => x.familyId)))
      .then((attributes: ICollectionDictionary<IProductWithAttributes> | null): IFamily[] | null => {
        this.productAttributes = [];
        this.attributes = attributes;
        this.products.forEach((product: IFamily) => {
          const reducedAttributes = attributes[String(product.familyId)]?.map((f: IProductWithAttributes) => f.attributes)
            .reduce((a: IAttribute[], b: IAttribute[]) => Array.prototype.concat.apply(a, b));
          this.productAttributes.push(reducedAttributes);
        });
        return families;
      });
  }

  public setFemilies(familyIds: number[]): ng.IPromise<IFamily[] | null> {
    return this.$q.when(fetchFamilies(familyIds))
      .then((families: IFamily[] | null) => (this.products = families));
  }

  public getSegmentTypeConfiguration(families: IFamily[] | null): ng.IPromise<IFamily[] | null> {
    const comparisonSegmentType: ProductComparisonSegmentTypeIndex = getComparisonSegmentType(families);
    return this.$q.when(fetchSegmentTypeConfiguration(this.configurationId, comparisonSegmentType))
      .then((configuration: IProductComparisonSegmentTypeConfiguration): IFamily[] | null => {
        this.attributeSets = configuration?.attributeSets || [];
        return families;
      });
  }

  public stopLoading() {
    this.loading = false;
  }
}
